'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alias = require('./alias');

var _alias2 = _interopRequireDefault(_alias);

var _STR_AREA = require('./_constants/STR_AREA');

var _STR_AREA2 = _interopRequireDefault(_STR_AREA);

var _STR_AREA_LC = require('./_constants/STR_AREA_LC');

var _STR_AREA_LC2 = _interopRequireDefault(_STR_AREA_LC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Area = (0, _alias2.default)(_STR_AREA_LC2.default, _STR_AREA2.default); /**
                                                                             * Alias for the area tag.  The Area tag defines a clickable area within
                                                                             * an image map.  Parent should be the Map component.
                                                                             *
                                                                             * @module Area
                                                                             * @func
                                                                             * @since 1.0.0
                                                                             * @param {Object} props
                                                                             */

exports.default = Area;